import { React, useState, useEffect, useContext, useRef, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import Form from "../../../component/utilities/Forms";
import editImg from "../../../assets/img/icon/edit.svg";
import { EditIcon, DeleteIcon, ViewIcon, CommentIcon } from "../../../component/utilities/ActionIcons";
import { Modal, Button } from "react-bootstrap";
import { AuthContext } from "../../../component/context/AuthContext";
import Swal from "sweetalert2";
import JoditEditor from "jodit-react";
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";
import parse from "html-react-parser";
import viewImg from "../../../assets/img/icon/index.png";
import deleteImg from "../../../assets/img/icon/delete.svg";
import { width } from "../../../component/utilities/ReactSwitchReactSwitchProps";

function EmployeeArticles() {
  const [authUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [validate, setValidate] = useState({});

  const handleClearValidate = (name) => {
    if (validate.validate && validate.validate[name]) {
      setValidate({
        validate: { ...validate.validate, [name]: undefined },
      });
    }
  };
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [questionId, setQuestionId] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [action, setAction] = useState("");
  const [show, setShow] = useState(false);
 const [activeTab, setActiveTab] = useState("all");
  const [searchParam, setSearchParam] = useState({
    srchStatus: "",
    srchTitle: ""
  });

  //Search
  const [searchQuestionTitle, setsearchQuestionTitle] = useState("");
  const [dataSort, setDataSort] = useState({
    order: "desc",
    order_by: "id",
  });
  const handlePageChange = (page) => {
    setActivePage(page);
  };

  const handleSort = (column, sortDirection) => {
    setDataSort({ order: sortDirection, order_by: column.sortField });
  };  
  //Form
  const [questionTitle, setQuestionTitle] = useState("");
  const [techDescription, setDescription] = useState("");
  const [allTechVersions, setAllTechVersions] = useState([]);
  const [techName, setTechName] = useState("");
  const [versionValue, setVersionValue] = useState("");
  const [viewShow, setViewShow] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [commentShow, setCommentShow] = useState(false);
  const [commentData, setCommentData] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);

  const normalizeVersionIds = (value) => {
    return String(value || "")
      .split(",")
      .map((v) => v.replace(/["']/g, "").trim())
      .filter(Boolean);
  };

  const getVersionIdsForQuestion = (questionVersions = [], versionOptions = []) => {
    return questionVersions
      .map((versionRow) => {
        const rawValue = versionRow?.versionData?.id ?? versionRow?.version_id;
        if (rawValue === undefined || rawValue === null) return "";

        const rawAsText = String(rawValue).trim();
        if (/^\d+$/.test(rawAsText)) {
          return rawAsText;
        }

        const matchedVersion = versionOptions.find(
          (option) => String(option.label).trim().toLowerCase() === rawAsText.toLowerCase()
        );
        return matchedVersion ? String(matchedVersion.value) : "";
      })
      .filter(Boolean);
  };

  const editor = useRef(null);
  const config = useMemo(() => ({
    readonly: false,
    uploader: { insertImageAsBase64URI: true },
  }), []);

  const params = useParams();
  const techId = params.id;

  let isToken = "";
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token ? authUserData[0].token : "";
  }

  useEffect(() => {
    fetchTechnologyById(techId);
    getVersions();
    fetchArticles(searchParam, dataSort, activePage, perPage, techId, activeTab);
  }, [searchParam, dataSort, activePage, techId, activeTab]);

  async function getVersions() {
    let apiUrl = CONST.GET_TECHNOLOGY_VERSIONS + `${techId}`;
    try {
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${isToken}` }
      });

      if (response.data.status === "success") {
        const options = response.data.data.map((v) => ({
          label: v.version,
          value: String(v.id),
        }));
        setAllTechVersions(options);
        return options;
      }
    } catch (error) {
      console.error("Error fetching versions:", error);
      toast.error("Unable to fetch versions.");
    }

    return [];
  }

  async function fetchTechnologyById(id) {
    let apiUrl = CONST.GET_TECHNOLOGY_BY_ID + `${id}`;
    await axios.put(apiUrl, {}, {
      headers: { Authorization: `Bearer ${isToken}` }
    }).then((response) => {
      if (response.data.status === "success") {
        setTechName(response.data.data.name);
      }
    });
  }

   async function fetchArticles(paramSearch, paramSort, paramPage, paramLimit, id, tab) {
    setLoading(true);

    try {
      const response = await axios.post(CONST.GET_QUESTIONS_LIST, {
        technology_id: id,
        view_context: 'employee_portal',
        limit: paramLimit,
        search_input: {
          srchStatus: paramSearch.srchStatus,
          srchTitle: paramSearch.srchTitle,
          filter_type: tab   
        },
        page_number: paramPage,
        sort: paramSort,
      }, {
        headers: { Authorization: `Bearer ${isToken}` }
      });

      if (response.data.status === "success") {
  setData(response.data.data || []);
  setTotalRows(response.data.count);
} else {
  // 🔥 IMPORTANT FIX
  setData([]);
  setTotalRows(0);
}

    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  }

  const fetchComments = async (questionId) => {
    setCommentLoading(true);
    setCommentShow(true);
    try {
      const response = await axios.post(CONST.GET_QUESTION_COMMENT_LIST, {
        question_id: questionId,
      }, {
        headers: { Authorization: `Bearer ${isToken}` }
      });
      if (response.data.status === "success") {
        setCommentData(response.data.data);
      } else {
        setCommentData([]);
      }
    } catch (error) {
      console.error(error);
      setCommentData([]);
    } finally {
      setCommentLoading(false);
    }
  };

  const handleShow = async (mode, id) => {
    setValidate({});
    setQuestionId(id);
    setQuestionTitle("");
    setVersionValue("");
    setDescription("");
    setAction(mode);

    let versionOptions = allTechVersions;
    if (!versionOptions.length) {
      versionOptions = await getVersions();
    }

    if (id !== 0) {
      await fetchArticleById(id, versionOptions);
    }

    setShow(true);
  };

  async function fetchArticleById(id, versionOptions = allTechVersions) {
    setLoading(true);
    let apiUrl = CONST.GET_QUESTION_BY_ID + `${id}`;
    await axios.put(apiUrl, {}, {
      headers: { Authorization: `Bearer ${isToken}` }
    }).then((response) => {
      if (response.data.status === "success") {
        const d = response.data.data;
        setQuestionTitle(d.title);
        setDescription(d.description);
        const selectedVersionIds = getVersionIdsForQuestion(
          d.question_versions || [],
          versionOptions
        );
        setVersionValue(selectedVersionIds.join(","));
      }
    });
    setLoading(false);
  }

  const handleClose = () => {
    setShow(false);
    setQuestionId(0);
    setValidate({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const selectedVersionIds = normalizeVersionIds(versionValue);

    let validator = Form.validator({
      versionValue: {
        value: selectedVersionIds.join(","),
        isRequired: true,
        label: "Version",
      },
      questionTitle: {
        value: questionTitle,
        isRequired: true,
        label: "Title",
      },
      techDescription: {
        value: techDescription,
        isRequired: true,
        label: "Description",
      },
    });

    if (validator) {
      setValidate({ validate: validator.errors });
      return;
    }

    setDisabled(true);
    setFullLoading(true);
    const apiUrl = questionId === 0 ? CONST.ADD_QUESTION : CONST.UPDATE_QUESTION;
    try {
      const response = await axios.post(apiUrl, {
        technology_id: techId,
        question_id: questionId,
        title: questionTitle,
        version_id: [selectedVersionIds.join(",")],
        description: techDescription,
        status: "1"
      }, {
        headers: { Authorization: `Bearer ${isToken}` }
      });

      if (response.data.status === "success") {
        toast.success(response.data.message);
        fetchArticles(searchParam, dataSort, activePage, perPage, techId, activeTab);
        handleClose();
      } else {
        toast.error(response.data.message || "Failed to submit article.");
      }
    } catch (error) {
      console.error("Error submitting article:", error);
      toast.error(error?.response?.data?.message || "Unable to submit article. Please try again.");
    } finally {
      setFullLoading(false);
      setDisabled(false);
    }
  };

  const deleteHandler = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete your article submission?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        await axios.delete(CONST.DELETE_QUESTION_DETAILS, {
          headers: { Authorization: `Bearer ${isToken}` },
          data: { technology_id: techId, question_id: id }
        }).then(() => {
          toast.success("Article deleted successfully");
          fetchArticles(searchParam, dataSort, activePage, perPage, techId);
        });
        setLoading(false);
      }
    });
  };

  const columns = [
    {width:"3%"},
    { name: "Sr. No", selector: (row, index) => (activePage - 1) * perPage + index + 1, width: "7%" },
    { name: "Technology", selector: () => techName, width: "20%" },
    { name: "Title", selector: row => row.title, width: "25%", sortable: true, sortField: "title" },
    { name: "Versions", selector: row => row.question_versions?.map(v => v.version_id).join(", "), width: "20%" },
    {
  name: "Status",
  width: "10%",
  omit: activeTab === 'all',
  cell: (row) => {
    const approvalStatus = row.approval_status || "pending";

    const formattedStatus =
      approvalStatus.charAt(0).toUpperCase() + approvalStatus.slice(1);

    return (
      <div className="d-flex justify-content-center">
        <span
          className={`db-status-badge ${
            approvalStatus === "approved"
              ? "db-badge-success"
              : approvalStatus === "rejected"
              ? "db-badge-danger"
              : "db-badge-warning"
          }`}
        >
          {formattedStatus}
        </span>
      </div>
    );
  },
},
   {
      name: "Action",
      width: "15%",
      cell: (row) => (
        <div className="d-flex align-items-center gap-1">
          {(activeTab === 'my' && (["pending", "rejected"].includes((row.approval_status || "pending").toLowerCase()) || authUserData[0]?.is_admin == 1)) && (
            <>
              <EditIcon onClick={() => handleShow("Edit", row.id)} tooltip="Edit & Resubmit" />
              <DeleteIcon onClick={() => deleteHandler(row.id)} tooltip="Delete Submission" />
            </>
          )}
          <CommentIcon onClick={() => fetchComments(row.id)} tooltip="View Comments" />
          <ViewIcon onClick={() => { setViewData(row); setViewShow(true); }} tooltip="View Details" />
        </div>
      )
    }
  ];
const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  currentPage,
}) => {
  const pages = Math.ceil(rowCount / rowsPerPage);
  const pageItems = Array.from({ length: pages }, (_, i) => i + 1);
 
  const nextDisabled = currentPage === pages;
  const previousDisabled = currentPage === 1;
 
  return (
    <div className="card-footer d-flex justify-content-between align-items-center">
      <p className="m-0 text-muted">
        Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
        {Math.min(currentPage * rowsPerPage, rowCount)} of {rowCount} entries
      </p>
 
      <ul className="pagination m-0 ms-auto">
        {/* Prev */}
        <li className={`page-item ${previousDisabled ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onChangePage(currentPage - 1)}
          >
            «
          </button>
        </li>
 
        {/* Numbers */}
        {pageItems
          .slice(Math.max(0, currentPage - 3), Math.min(pages, currentPage + 2))
          .map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active" : ""}`}
            >
              <button
                className="page-link"
                style={
                  currentPage === page
                    ? {
                        backgroundColor: "#0d6efd",
                        borderColor: "#0d6efd",
                        color: "#fff",
                      }
                    : {}
                }
                onClick={() => onChangePage(page)}
              >
                {page}
              </button>
            </li>
          ))}
 
        {/* Next */}
        <li className={`page-item ${nextDisabled ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onChangePage(currentPage + 1)}
          >
            »
          </button>
        </li>
      </ul>
    </div>
  );
};
  return (
    <>
      <Loading loading={fullLoading} background="rgba(0,0,0,0.5)" loaderColor="#fff" />
      <HeaderSection
        title={techName}
        heading="Articles"
        addButton={() => handleShow("Add", 0)}
        addLinkName="Add New Article"
        linktype="add"
      />
      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center pb-2">
              <h3 className="card-title">Articles for {techName}</h3>
              <Link to={CONST.ADMIN_PRE + "account/articles"} className="btn btn-link btn-outline-primary btn-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-left" width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M5 12l14 0"></path>
                      <path d="M5 12l6 6"></path>
                      <path d="M5 12l6 -6"></path>
                  </svg>
                  Back to technologies
              </Link>
            </div>
            {/* Tab Navigation */}
            <div className="px-3 pt-2 border-bottom">
              <ul className="nav nav-tabs card-header-tabs border-0">
                <li className="nav-item">
                  <button 
                    className={`nav-link border-0 ${activeTab === 'all' ? 'active fw-bold text-primary border-bottom border-3 border-primary' : 'text-muted'}`}
                    onClick={() => {
                      setActiveTab('all');
                      setActivePage(1);
                    }}
                    style={{ background: 'transparent' }}
                  >
                    All Articles
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link border-0 ${activeTab === 'my' ? 'active fw-bold text-primary border-bottom border-3 border-primary' : 'text-muted'}`}
                    onClick={() => {
                                        setActiveTab('my');
                                        setActivePage(1);
        
                                  }}
                    style={{ background: 'transparent' }}
                  >
                    My Submissions
                  </button>
                </li>
              </ul>
            </div>

            <div className="card-body border-bottom py-3">
              <div className="row align-items-end">
 
                {/* Search Input */}
                <div className="col-md-6">
                  <label className="form-label">Search Articles</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter article title..."
                    value={searchQuestionTitle}
                    onChange={(e) => setsearchQuestionTitle(e.target.value)}
                  />
                </div>
 
                {/* Buttons */}
                <div className="col-md-6">
                  <div className="d-flex gap-2 mt-2 mt-md-0 ">
 
                    {/* Search Button */}
                    <button
                      type="button"
                      className="btn btn-primary d-flex align-items-center mr-2"
                      onClick={() =>
                        setSearchParam({ ...searchParam, srchTitle: searchQuestionTitle })
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-search me-1"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                      >
                        <circle cx="10" cy="10" r="7"></circle>
                        <line x1="21" y1="21" x2="15" y2="15"></line>
                      </svg>
                      Search
                    </button>
 
                    {/* Clear Button */}
                    <button
                      type="button"
                      className="btn btn-outline-secondary d-flex align-items-center"
                      onClick={() => {
                        setsearchQuestionTitle("");
                        setSearchParam({ ...searchParam, srchTitle: "" });
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-x me-1"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                      >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                      Clear
                    </button>
 
                  </div>
                </div>
 
              </div>
            </div>
            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={data}
                progressPending={loading}
                progressComponent={
                  <div className="p-4">
                    <DivLoader color="primary" />
                  </div>
                }
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                paginationPerPage={perPage}
                paginationComponent={BootyPagination}
                sortServer
                onSort={handleSort}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{action} Article</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label required">Select Version(s)</label>
                <MultiSelect
                  value={versionValue}
                  onChange={(val) => {
                    setVersionValue(val);
                    handleClearValidate("versionValue");
                  }}
                  options={allTechVersions}
                  className={validate.validate?.versionValue ? "is-invalid" : ""}
                />
                {validate.validate?.versionValue && (
                  <div className="invalid-feedback d-block">
                    {validate.validate.versionValue}
                  </div>
                )}
              </div>
              <div className="col-12">
                <label className="form-label required">Article Title</label>
                <input
                  className={`form-control ${validate.validate?.questionTitle ? "is-invalid" : ""}`}
                  value={questionTitle}
                  onChange={(e) => {
                    setQuestionTitle(e.target.value);
                    handleClearValidate("questionTitle");
                  }}
                  placeholder="E.g. How to install React"
                />
                {validate.validate?.questionTitle && (
                  <div className="invalid-feedback">
                    {validate.validate.questionTitle}
                  </div>
                )}
              </div>
              <div className="col-12">
                <label className="form-label required">Content / Description</label>
                <JoditEditor
                  ref={editor}
                  config={config}
                  value={techDescription}
                  onBlur={(newContent) => {
                    setDescription(newContent);
                    if (newContent) handleClearValidate("techDescription");
                  }}
                />
                {validate.validate?.techDescription && (
                  <div className="invalid-feedback d-block">
                    {validate.validate.techDescription}
                  </div>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={disabled}>{disabled ? "Submitting..." : "Submit Article"}</Button>
        </Modal.Footer>
      </Modal>

      <ViewArticleModal 
        show={viewShow} 
        handleClose={() => setViewShow(false)} 
        data={viewData} 
      />

      <Modal size="lg" show={commentShow} onHide={() => setCommentShow(false)} centered>
        <Modal.Header closeButton className="bg-primary text-white custom-modal-header">
          <Modal.Title className="fw-bold">Article Comments</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light p-4">
          <div className="card shadow-sm border-0 rounded-3">
            <div className="card-body p-4">

              {commentLoading ? (
                <div className="text-center p-5">
                  <DivLoader color="primary" />
                  <p className="mt-2 text-muted">Loading comments...</p>
                </div>
              ) : commentData && commentData.filter(c => String(c.is_approve || c.status) === "1").length > 0 ? (
                <div className="comment-list" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                  {commentData.filter(c => String(c.is_approve || c.status) === "1").map((comment, index) => (
                    <div key={index} className="p-3 border rounded-3 bg-white mb-4 comment-item-hover" style={{ borderLeft: '4px solid #0d6efd !important' }}>
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="d-flex align-items-center">
                          <div className="avatar bg-dark text-white rounded-circle mr-3 d-flex align-items-center justify-content-center me-3" style={{ width: '45px', height: '45px', fontSize: '1.2rem', fontWeight: 'bold' }}>
                            {comment.name ? comment.name.charAt(0).toUpperCase() : 'A'}
                          </div>
                          <div className="border-bottom" style={{ minWidth: '200px', paddingBottom: '5px' }}>
                            <h5 className="fw-bold mb-0 text-dark">{comment.name || 'Anonymous User'}</h5>
                            <small className="text-muted">{comment.email}</small>
                          </div>
                        </div>
                      </div>
                      
                      <div className="text-secondary px-2 mb-2" style={{ minHeight: '30px' }}>
                        {comment.comment}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center w-100 p-5">
        <div className="card shadow-sm border-0 bg-white text-center" style={{ width: '100%', maxWidth: '500px' }}>
          <div className="card-body d-flex flex-column align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="text-muted mb-3"
              width="64"
              height="64"
              viewBox="0 0 24 24"
              strokeWidth="1"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M8 9h1m4 0h3"></path>
              <path d="M8 13h5"></path>
              <path d="M8 4h10a2 2 0 0 1 2 2v8m-2 4h-10l-3 3v-3h-2a2 2 0 0 1 -2 -2v-8c0 -1.1 .9 -2 2 -2"></path>
              <path d="M3 3l18 18"></path>
            </svg>

            <h4 className="text-dark m-0">No comments found</h4>

            <p className="text-muted mt-2 mb-0" style={{ maxWidth: "300px" }}>
              There are currently no discussions for this article.
            </p>
          </div>
        </div>
      </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-white border-0">
          <Button variant="light" className="px-4 shadow-sm" onClick={() => setCommentShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const ViewArticleModal = ({ show, handleClose, data }) => (
  <Modal size="lg" show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{data?.title}</Modal.Title>
    </Modal.Header>

    <Modal.Body className="bg-light">
      <div className="card shadow-sm border-0">
        <div className="card-body">

          {/* HEADER WITH STATUS BADGE */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="text-primary m-0">Article Detailed Description</h4>

            {data?.approval_status && (
              <span
                className={`db-status-badge ${
                  data.approval_status === "approved"
                    ? "db-badge-success"
                    : data.approval_status === "rejected"
                    ? "db-badge-danger"
                    : "db-badge-warning"
                }`}
              >
  {data.approval_status
    ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
    : ""}
</span>
            )}
          </div>

          <hr />

          {/* CONTENT BOX */}
          <div
            className="article-content border p-4 rounded bg-white comment-item-hover"
            style={{ maxHeight: "50vh", overflowY: "auto" }}
          >
            {data?.description
              ? parse(data.description)
              : "No content available."}
          </div>

          {/* REJECTION REASON (ONLY IF REJECTED) */}
          {data?.approval_status === "rejected" &&
            data?.rejection_reason && (
              <div className="mt-4 p-3 border border-danger rounded bg-light">
                <h5 className="text-danger mb-2">
                  Rejection Reason:
                </h5>
                <p className="mb-0">{data.rejection_reason}</p>
              </div>
            )}

        </div>
      </div>
    </Modal.Body>

    <Modal.Footer>
      <Button variant="secondary" className="btn btn-secondary" onClick={handleClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);
export default EmployeeArticles;
